import { type FC } from 'react';

export interface FrameProps {
  src: string;
  title?: string;
  width?: string;
  height?: string;
  border?: boolean;
  referrerPolicy?: React.IframeHTMLAttributes<HTMLIFrameElement>['referrerPolicy'];
  /** Custom iframe allow attribute (e.g., "encrypted-media" for Spotify) */
  allow?: string;
}

/**
 * Secure iframe wrapper for embed content
 * Ported from brainfish-platform/app/components/Markdown/Frame.tsx
 */
export const Frame: FC<FrameProps> = ({
  src,
  title,
  width = '100%',
  height = '400px',
  border = false,
  referrerPolicy = 'strict-origin-when-cross-origin',
  allow,
}) => {
  return (
    <div className={`overflow-hidden rounded-lg ${border ? 'border' : ''}`} style={{ width, height }}>
      <iframe
        src={src}
        sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads allow-presentation"
        referrerPolicy={referrerPolicy}
        width={width}
        height={height}
        title={title || 'embed'}
        loading="lazy"
        allowFullScreen
        allow={allow}
        className="block rounded-lg"
      />
      {title && <span className="block text-center text-sm font-medium">{title}</span>}
    </div>
  );
};
